// extracted by mini-css-extract-plugin
export default {"buttonRow":"ForgotPassword_buttonRow__KiiHb","descriptionText":"ForgotPassword_descriptionText__mvCZ0"};